import { useState } from 'react'
import SiteFooter from '../components/SiteFooter'
import SiteHeader from '../components/SiteHeader'
import s from './Faq.module.css'

const QA = [
  {
    q: '무료로 얼마나 쓸 수 있나요?',
    a: 'Free 플랜은 기간 제한 없이 무료입니다. AI 에이전트 2개와 월 100건 자동화까지 쓸 수 있고, 카드 등록도 필요 없습니다.',
  },
  {
    q: '플랜은 언제든 바꿀 수 있나요?',
    a: '네. 약정이 없어 언제든 올리거나 내릴 수 있고, 해지도 즉시 가능합니다.',
  },
  {
    q: '시작하는 데 얼마나 걸리나요?',
    a: '가입 후 3분이면 온보딩이 끝납니다. 별도 설치나 개발 작업 없이 바로 쓸 수 있습니다.',
  },
  {
    q: '제 데이터는 안전한가요?',
    a: '전송·저장 구간 모두 암호화하며, 학습 목적으로 고객 데이터를 사용하지 않습니다. 해지하면 데이터는 삭제됩니다.',
  },
  {
    q: '쓰던 시스템과 연동되나요?',
    a: 'Pro 플랜에서 기존 시스템 API 연동을 지원합니다. 연동 대상이 특수한 경우 문의 주시면 확인해 드립니다.',
  },
  {
    q: '자동화 건수는 어떻게 세나요?',
    a: '에이전트가 실행을 한 번 끝낼 때마다 1건입니다. 남은 건수는 대시보드에서 실시간으로 확인할 수 있습니다.',
  },
]

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0)

  return (
    <div className={s.page}>
      <SiteHeader current="#/faq" />

      <div className={s.body}>
        <div className={s.wrap}>
          <div className={`${s.head} enter`}>
            <h1>자주 묻는 질문</h1>
            <p>찾는 답이 없으면 채팅으로 문의해 주세요.</p>
          </div>

          {/* details/summary는 닫힐 때 내용이 통째로 숨겨져 높이 전환이 안 걸린다.
              부드럽게 펼치려면 버튼 + 패널로 두고 grid-template-rows를 애니메이션해야 한다. */}
          <div className={`${s.faq} enter enter-1`}>
            {QA.map((item, i) => (
              <div key={item.q} className={s.qa} data-open={open === i}>
                <button
                  type="button"
                  id={`faq-q${i}`}
                  aria-expanded={open === i}
                  aria-controls={`faq-a${i}`}
                  onClick={() => setOpen(open === i ? null : i)}
                >
                  {item.q}
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="m6 9 6 6 6-6" />
                  </svg>
                </button>
                <div className={s.panel} id={`faq-a${i}`} role="region" aria-labelledby={`faq-q${i}`}>
                  <p>{item.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <SiteFooter />
    </div>
  )
}
